import React, { useEffect, useState } from 'react';
import ReactSelect, { ActionMeta, MultiValue, SingleValue } from 'react-select';
import { IOption, TOptions } from '../Input/Input';


export type TMenuPosition = "fixed" | "absolute";

interface IProps {
  options?: TOptions;
  name: string;
  value: string | string[];
  placeholder?: string;
  multiple?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onChange: (value: string | string[]) => void;
  menuPosition?: TMenuPosition;
}


const getSelectValues = (options: TOptions, values: string[]) => {
  let sValues: IOption[] = [];
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if ("value" in option) {
      if (values.includes(option.value.toString())) {
        sValues.push(option);
      }
    } else if ("options" in option) {
      sValues = [...sValues, ...getSelectValues(option.options, values)];
    }
  }
  return sValues;
}

const getSelectValue = (options: TOptions, value: string): IOption | undefined => {
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if ("value" in option) {
      if (option.value.toString() === value.toString()) {
       return option;
      }
    } else if ("options" in option) {
      const newOption = getSelectValue(option.options, value);
      if (newOption) {
        return newOption;
      }
    }
  }
  return undefined;
}

const Select: React.FC<IProps> = ({ options, name, placeholder, multiple, loading, disabled, value, onChange, menuPosition = 'absolute' }) => {
  const [selectValue, setSelectValue] = useState<IOption | IOption[] | undefined>();

  useEffect(() => {
    if (value && (value.length || typeof value === 'number') && options) {
      if (multiple) {
        const values = (value as string[]).map(value => value.toString());
        // setSelectValue(options.filter(option => values.includes(option.value.toString())));
        setSelectValue(getSelectValues(options, values));
      } else {
        // setSelectValue(options.find(option => option.value.toString() === value.toString()));
        setSelectValue(getSelectValue(options, value.toString()))
      }
    } else {
      setSelectValue(undefined);
    }

  }, [value, options, multiple]);

  const changeHandler = (value: SingleValue<IOption> | MultiValue<IOption>, actionMeta: ActionMeta<IOption>) => {
    if (multiple) {
      onChange((value as MultiValue<IOption> | undefined)?.map(value => value.value) || '')
    } else {
      onChange((value as SingleValue<IOption> | undefined)?.value || '');
    }
  }

  return (
    <ReactSelect
      key={`${name}_${selectValue}`}
      name={name}
      onChange={changeHandler}
      isLoading={loading}
      value={selectValue}
      placeholder={placeholder}
      options={options}
      isDisabled={disabled}
      isSearchable
      isClearable
      isMulti={multiple}
      menuPosition={menuPosition}
    />
  );
};

export default Select;
